import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import contactPortalService from '../services/contactPortal';
import './ContactPortal.scss';

const ContactPasswordResetRequest = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await contactPortalService.requestPasswordReset(email.trim());
      setSuccess(response.message || 'Si el email corresponde a una cuenta activa, enviamos instrucciones para restablecer la contrasena.');
    } catch (err) {
      const message = err.response?.data?.detail || 'No se pudo procesar la solicitud.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-portal-auth-page">
      <div className="auth-card">
        <h1>Recuperar contrasena</h1>
        <p>Te enviaremos un enlace para restablecer tu contrasena.</p>

        <form onSubmit={onSubmit}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Enviando...' : 'Enviar instrucciones'}
          </button>
        </form>

        <p className="auth-footer">
          <Link to="/contactos/login">Volver a Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ContactPasswordResetRequest;
